import Button from "../forms/Button/Button";
import Flex from "../Flex/Flex";
import React from "react";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "../Modal/Modal";
import Checkbox from "../forms/Checkbox/Checkbox";
import { SessionStorageKeys } from "@/utils/sessionStorageUtils";
import { setLocalStorageItem } from "@/utils/localStorageUtils";

export interface ConfirmModalProps {
  open: boolean;
  onClose: (confirmed: boolean) => void;

  loading?: boolean; // show loading indicator instead of footer and close buttons, and forbid closing the modal.

  title?: string;
  body?: React.ReactNode;
  confirmButtonLabel?: string;
  confirmButtonSentinment?: "primary" | "danger";
  width?: string;
  hideFooter?: boolean;

  rememberDecisionSessionStorageKey?: SessionStorageKeys;
}

export default function ConfirmModal(props: ConfirmModalProps) {
  return (
    <Modal
      inlineWidth={props.width}
      closeOnOutsideClick={false} // disabling to prevent accidental click-outside-decline actions
      closeIcon={!props.loading}
      open={props.open}
      onClose={() => props.onClose(false)}
      onOpenChange={(open: boolean) => {}}
    >
      <ModalHeader><h3>{props.title ?? "Confirm Action"}</h3></ModalHeader>

      <ModalBody>
        {props.body}
      </ModalBody>

      {!props.hideFooter && (
        <ModalFooter>
          {props.loading ? <LoadingSpinner size="2rem" /> : (
            <Flex justify="space-between" align="center">
              <Flex align="center" gap={1}>
                {props.rememberDecisionSessionStorageKey && (
                  <>
                    <Checkbox
                      onChange={(value) => {
                        if (value) {
                          setLocalStorageItem(props.rememberDecisionSessionStorageKey, true);
                        } else {
                          setLocalStorageItem(props.rememberDecisionSessionStorageKey, false);
                        }
                      }}
                    />
                    <span>Don&apos;t show again</span>
                  </>
                )}
              </Flex>

              <Flex align="center" gap={2}>
                <Button size="large" type="secondary" onClick={() => props.onClose(false)}>
                  Cancel
                </Button>

                <Button size="large" type={props.confirmButtonSentinment ?? "primary"} onClick={() => props.onClose(true)}>
                  {props.confirmButtonLabel ?? "Confirm"}
                </Button>
              </Flex>
            </Flex>
          )}
        </ModalFooter>
      )}
    </Modal>
  );
}
